/** Represents the possible HTTP METHODS / VERBS a request may be made with. */
export enum HTTPMethod {
  Get = 'GET',
  Post = 'POST',
  Delete = 'DELETE',
  Put = 'PUT',
  Patch = 'PATCH'
}
